import { rem } from 'polished';
import styled from '../../../styles/theme';
import { MarketingStickerStyled } from '../MarketingStickerStyled';

export const MarketingStickerStyledDS = styled(MarketingStickerStyled)`
    background: rgba(181, 30, 65, 0.2);
    height: ${rem(26)};
    top: ${rem(16)};

    .infoText {
        font-size: ${rem(16)};
    }

    .infoIcon {
        top: ${rem(5)};
        height: ${rem(16)};
        width: ${rem(16)};

        svg {
            height: ${rem(16)};
            width: ${rem(16)};
        }
    }
`;
